import React from "react";
import "./RouletteWheelMobile.scss";
import RouletteWheel from "../RouletteWheel";

const RouletteWheelMobile = (props) => {
    return (
        <div className="rmw">
            <div className="rmw__viewport">
                <div className="rmw__scale">
                    <RouletteWheel {...props} />
                </div>
            </div>
        </div>
    );
};

export default RouletteWheelMobile;